import React from 'react';
import { Link } from 'react-router-dom';
import Rating from '@mui/material/Rating';

const Product = ({ product }) => {
    return (
        <Link to={`/product/${product._id}`} className='productBlock'>
            <img src={product.images[0]?.url} alt={product.name} />
            <h5>{product.name}</h5>
            <p>{product.description}</p>
            <div>
                <Rating size='large' precision={0.5} value={product.ratings} readOnly />
                <span className='ps-2 ratingText'>{product.numOfReviews} Reviews</span>
            </div>
            <h6>${product.price}</h6>
        </Link>
    );
};

export default Product;
